<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="80%"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-table
          :data="tableList"
          ref="tableList"
          style="width: 100%"
          height="calc(100%)"
        >
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>

          <el-table-column label="备件编号" align="center" prop="Code" sortable>
          </el-table-column>
          <el-table-column label="备件名称" align="center" prop="Name" sortable>
          </el-table-column>
          <el-table-column
            label="备件类型"
            align="center"
            prop="MaterialTypeName"
            sortable
          >
          </el-table-column>
          <el-table-column label="备件规格" align="center" prop="Spec" sortable>
          </el-table-column>
          <el-table-column
            label="单位"
            align="center"
            prop="storageName"
            sortable
          >
          </el-table-column>

          <el-table-column
            label="货位"
            align="center"
            prop="LocalName"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="库存数量"
            align="right"
            prop="Nums_N"
            sortable
          >
          </el-table-column>
          <el-table-column label="工单数量" align="right" prop="Num" sortable>
          </el-table-column>
          <el-table-column
            label="剩余领料数量"
            align="right"
            prop="RemainingQuantity"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="本次领料数量"
            align="center"
            prop="Quantity"
            sortable
          >
            <template slot-scope="scope">
              <el-input
                @input="NumChange($event, scope.row)"
                v-model="scope.row.Quantity"
                type="number"
                :controls="false"
                style="width: 100%"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button @click="handleSubmit" type="primary">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      loading: false,
      tableList: [],
      drawer: false,
      row: {},
    }
  },
  props: {},
  components: {},
  methods: {
    handleSubmit() {
      if (this.tableList.length > 0) {
        let isNum = this.tableList.some((item) => {
          return Number(item.Num) > 0
        })

        console.log(isNum, 'every')
        if (!isNum) {
          this.$notify.error('请至少输入一种备件的领料数量')
          return
        }
      }
      this.$confirm(`此操作将领料后生成对应领料出库单, 是否继续?`, {
        type: 'warning',
      }).then(() => {
        this.loading = true
        this.$http
          .post('/Base_DeviceTreeManage/Device_WorkOrder/ApplyMaterialData', {
            WorkOrderId: this.row.Id,
            device_WorkOrderItems: [...this.tableList],
          })
          .then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('领料成功')
              this.close()
              this.$emit('success')
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    NumChange(num, row) {
      console.log(num, row)
      if (!Number.isInteger(Number(num))) {
        this.$notify.error('领料数量不能为小数或负数')
        this.$set(row, 'Quantity', Math.floor(Number(num)))
      } else if (Number(num) < 0) {
        this.$notify.error('领料数量不能为小数或负数')
        this.$set(row, 'Quantity', 0)
      } else if (Number(num) > Number(row.RemainingQuantity)) {
        this.$notify.error('领料数量不能超过剩余领料数量')
        this.$set(row, 'Quantity', row.RemainingQuantity)
      } else if (Number(num) > Number(row.Nums_N)) {
        this.$notify.error('领料数量不能超过库存数量')
        this.$set(row, 'Quantity', row.Nums_N)
      }
    },
    openForm(title, row = {}) {
      this.drawer = true
      this.title = title
      this.tableList = []
      this.row = row
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post(
          '/Base_DeviceTreeManage/Device_WorkOrderItem/GetDeviceWorkOrderItemList',
          {
            id,
          }
        )
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableList = resJson.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
  overflow-y: auto;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
